import { ja } from '@/i18n/ja';

/**
 * lawsnote.com/jp のフッターに合わせた最小構成。
 * 既存サイトへ組み込む場合は、このコンポーネントごと既存 Footer に差し替える。
 */
export function Footer() {
  return (
    <footer className="mt-16 border-t border-line bg-surface-muted">
      <div className="mx-auto flex max-w-5xl flex-col gap-3 px-5 py-8 text-[13px] text-ink-muted">
        <p>{ja.footer.note}</p>

        <p>
          <a
            href={ja.footer.blogUrl}
            className="text-brand underline underline-offset-2 hover:no-underline"
          >
            {ja.footer.blog}
          </a>
        </p>

        <p className="flex flex-wrap items-center gap-x-2 gap-y-1 text-ink-subtle">
          <a
            href={ja.footer.policyUrl}
            className="text-brand underline underline-offset-2 hover:no-underline"
          >
            {ja.footer.policy}
          </a>
          <span aria-hidden="true">｜</span>
          <span>{ja.footer.copyright}</span>
        </p>
      </div>
    </footer>
  );
}
